import { render, staticRenderFns } from "./QuestionGraphTabNew.vue?vue&type=template&id=6aae28cb"
import script from "./QuestionGraphTabNew.vue?vue&type=script&lang=ts"
export * from "./QuestionGraphTabNew.vue?vue&type=script&lang=ts"
import style0 from "./QuestionGraphTabNew.vue?vue&type=style&index=0&id=6aae28cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
